'use strict';

var translations = {
    warnings: {
        straightRow: 'Tránh sử dụng các dãy phím thẳng hàng, ví dụ như "asdf".',
        simpleRepeat: 'Tránh các từ và ký tự lặp lại, như "aaa" và "abcabc".',
        extendedRepeat: 'Tránh các từ và ký tự lặp lại, như "aaa" và "abcabc".',
        sequences: 'Tránh các chuỗi ký tự như "abc" hoặc "6543".',
        recentYears: 'Tránh những năm gần đây, như "2020".',
        dates: 'Tránh sử dụng ngày tháng.',
        topTen: 'Tránh sử dụng những mật khẩu phổ biến.',
        topHundred: 'Tránh sử dụng những mật khẩu phổ biến.',
        common: 'Tránh sử dụng những mật khẩu phổ biến.',
        similarToCommon: 'Tránh sử dụng những mật khẩu phổ biến.',
        wordByItself: 'Tránh sử dụng một từ đơn lẻ.',
        namesByThemselves: 'Tránh chỉ dùng mỗi tên và họ.',
        commonNames: 'Tránh chỉ dùng mỗi tên và họ.',
        userInputs: '',
        pwned: '',
        keyPattern: '',
    },
    suggestions: {
        useWords: 'Dùng một chuỗi dài hơn hai từ; tránh các cụm từ thông dụng.',
        anotherWord: 'Thêm một hoặc hai từ nữa. Những từ ít phổ biến thì tốt hơn.',
        repeated: 'Tránh các từ và ký tự lặp lại, như "aaa" và "abcabc".',
        l33t: 'Tránh sử dụng các ký tự thay thế dễ đoán như "@" thay vì "a" (như trong "@pple" thay vì "Apple").',
        reverseWords: 'Tránh những từ đảo ngược như "elppa" (đảo ngược của "apple").',
        allUppercase: 'Viết toàn bộ chữ in hoa cũng dễ đoán như viết toàn bộ chữ thường.',
        dates: 'Tránh sử dụng ngày tháng.',
        associatedYears: 'Tránh sử dụng ngày tháng.',
        recentYears: 'Tránh những năm gần đây, như "2020".',
        sequences: 'Tránh các chuỗi ký tự như "abc" hoặc "6543".',
        pwned: '',
        capitalization: '',
        longerKeyboardPattern: '',
        noNeed: '',
    },
    timeEstimation: {
        ltSecond: 'less than a second',
        second: '{base} second',
        seconds: '{base} seconds',
        minute: '{base} minute',
        minutes: '{base} minutes',
        hour: '{base} hour',
        hours: '{base} hours',
        day: '{base} day',
        days: '{base} days',
        month: '{base} month',
        months: '{base} months',
        year: '{base} year',
        years: '{base} years',
        centuries: 'centuries',
    },
};

export default translations;
//# sourceMappingURL=translations.js.map
